<template>
  <div class="call-ended">
    <div class="call-ended-card">
      <svg class="call-ended-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 4 .64 2 2 0 0 1 2 2v3.28a2 2 0 0 1-1.82 2A19.79 19.79 0 0 1 3 4.82 2 2 0 0 1 5 3h3.28a2 2 0 0 1 2 1.53 12.84 12.84 0 0 0 .64 4 2 2 0 0 1-.45 2.11z" />
        <line x1="1" y1="1" x2="23" y2="23" />
      </svg>
      <h2>{{ $t('callEnded') }}</h2>
      <p>{{ $t('callEndedMessage') }}</p>
    </div>
  </div>
</template>

<style scoped>
.call-ended {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.call-ended-card {
  text-align: center;
  padding: 48px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  max-width: 400px;
}

.call-ended-icon {
  width: 56px;
  height: 56px;
  color: #999;
  margin-bottom: 16px;
}

.call-ended-card h2 {
  margin: 0 0 8px;
  font-size: 20px;
  font-weight: 600;
  color: #333;
}

.call-ended-card p {
  margin: 0;
  font-size: 14px;
  color: #888;
}
</style>
